import { DatePipe } from '@angular/common';
import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { Observable, Subject, interval } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { DynamicHelpListComponent } from './dynamic-help-list/dynamic-help-list.component';
import { HelpListPopupComponent } from './help-list-popup/help-list-popup.component';
import * as moment from 'moment';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
@Component({
  selector: 'app-doctor-other-info',
  templateUrl: './doctor-other-info.component.html',
  styleUrls: ['./doctor-other-info.component.scss'],
  providers: [VoiceRecognitionService]
})
export class DoctorOtherInfoComponent implements OnInit {
  destroydother$: Subject<boolean> = new Subject<boolean>();
  private nextreviewrocesses: any = [];
  private showspinner: boolean = false;
  private imunizationdescription: any = '';
  private fallrsikdescription: any = '';
  private Excommentdescription: any = '';
  private progressivedescription: any = '';
  private Nutritionaldescription: any = '';
  private planOfCaredescription: any = '';
  private refReasondescription: any = '';
  private pCommentdescription: any = '';
  private pgDoctor: any = '';
  private doctorRemark: any = '';
  private counselorRemark: any = '';
  private referralDoctorName: string = '';
  private gvprRemark: string = '';
  private investigationRemarks: string = '';
  private managementRemarks: string = '';
  private commanMsgArray: any = [];
  private examid: number;
  private referredCC: boolean = false;
  private GVP: boolean = false;
  private examdetailArray: any = [];
  private subsepceialdata: any = [];
  private subSpecialityName: any = '';
  private subspecialityID: number = 0;
  private doctorsId: number = 0;
  // subSpecialityCtrl: FormControl;
  // subSpecialityOptions: Observable<any[]>;
  private doctors: any;
  // filterTerm:any; 
  // private doctorsName: string = '';
  private DoctorCtrl: FormControl;
  private filteredDoctorArray: Observable<any[]>;
  private rowClicked: any;
  isheader: boolean = false;
  @Input() docterinfomodule: any;
  opdFieldSequence: string[] = [
    'imunizationlist',
    'fallRisk',
    'prognosis',
    'nutritionalAdvice',
    'nextVisitPlan',
    'referralReason',
    'personalRemarks',
    'doctorRemark',
    'referralDoctorName',
    'gvpr',
    'investigation',
    'management',
    'opeartor',
  ];


  opdCurrentFieldIndex: number = -1;
  isVoiceEnabled: boolean = false;

  constructor(private emrservice: EMRService, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DoctorOtherInfoComponent>, private authService: AuthService, private datePipe: DatePipe,
    private opdvisitService: OpdVisitService, private dashboardService: DashboardService, private dialog: MatDialog,
    private VoiceRecognitionService: VoiceRecognitionService,
    private voice: VoiceRecognitionService) { }

  /** AI Scribe: apply spoken plan/advice/prognosis/referral to this form, then clear. */
  consumeAiOtherInfo(): void {
    const p = this.emrservice.aiWorkupPending;
    if (!p || !p.otherInfo) { return; }
    const o = p.otherInfo;
    const d: any = this.opdvisitService.patientDrdetaill && this.opdvisitService.patientDrdetaill[0];
    if (!d || d.aiInfoFilled) { return; }   // idempotent; re-applies if the form object is reloaded
    if (o.prognosis) { d.prognosis = o.prognosis; }
    if (o.nutritionalAdvice) { d.nutritionalAdvice = o.nutritionalAdvice; }
    if (o.nextVisitPlan) { d.nextVisitPlan = o.nextVisitPlan; }
    if (o.managementRemarks) { d.managmentRemarks = o.managementRemarks; }
    if (o.referralReason) { d.referralReason = o.referralReason; }
    if (o.drRemarks) { d.drRemarks = o.drRemarks; }
    d.aiInfoFilled = true;
    this.emrservice.enabledisablebtnInfo = false;
  }

  /** Per-tab AI fill — applies only the other-info slice. */
  aiFillOtherInfo(s: any): void {
    const d: any = this.opdvisitService.patientDrdetaill && this.opdvisitService.patientDrdetaill[0];
    if (d) { d.aiInfoFilled = false; }
    this.emrservice.applyAiWorkup({ otherInfo: (s && s.otherInfo) || {} });
  }

  ngOnInit(): void {
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.emrservice.enabledisablebtnInfo = true;

    // AI Scribe — pre-fill plan/advice/prognosis from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroydother$)).subscribe(() => this.consumeAiOtherInfo());
    interval(1500).pipe(takeUntil(this.destroydother$)).subscribe(() => this.consumeAiOtherInfo());

    this.emrservice.share.pipe(takeUntil(this.destroydother$)).subscribe((x: any) => {
      if (x == 2) {
        // this.getReviewData(this.opdvisitService.patientdetails.pkRegId);
        this.examid = this.emrservice.examid;
        this.referralDoctorName = this.opdvisitService.patientDrdetaill[0].requestToOtherDoctor;
        this.getSpecilityData(0);
      }

      if (x == 22) {
        this.examid = this.emrservice.examid;
        this.referralDoctorName = this.opdvisitService.patientDrdetaill[0].requestToOtherDoctor;
      }
    });

    this.getSpecilityData(0);
    // this.subSpecialityCOntrol();
    this.getDoctorBrach();
    // this.doctorControll();
    this.rowClicked = -1;
    this.DoctorCtrl = new FormControl();
    this.emrservice.componentClicked$.subscribe(() => {
      if (!this.emrservice.enabledisablebtnInfo) {
        if (this.emrservice.examid > 0) {
          this.examid = this.emrservice.examid;
          this.SaveData(1);
        }

      } else {
        setTimeout(() => {
          this.showspinner = false;
        }, 500);
      }
    });
  }
  ngOnDestroy(): void {
    this.voice.stopDischarge(this.getCurrentField());
    this.voice.destroy();
    this.destroydother$.next(true);
    this.destroydother$.unsubscribe();
    this.examdetailArray = null;
    this.subsepceialdata = null;
    this.commanMsgArray = null;
    this.nextreviewrocesses = null;
    this.isVoiceEnabled = false

  }

  getDoctorBrach() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroydother$)).
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }

  success_doctors(data) {

    if (this.authService.masterdata.isExternal === true) {
      this.opdvisitService.doctors = data.filter(item => item.isExternal == false);
      this.doctorControll();
    }
    else {
      this.opdvisitService.doctors = data;
      this.doctorControll();
    }

    // if (this.opdvisitService.patientDrdetaill[0]?.fK_RequestDoctorId > 0) {
    //   const DoctorName = this.opdvisitService.doctors.filter(item => item.userId == this.opdvisitService.patientDrdetaill[0]?.fK_RequestDoctorId);
    //   if (DoctorName.length > 0) {
    //     this.doctorsName = DoctorName[0]?.userName;

    //   } else {
    //     this.doctorsName = null;
    //   }
    // } else {
    //   this.doctorsName = null;
    // }
  }
  failed_doctors(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  //autocomplet
  doctorControll() {
    this.DoctorCtrl = new FormControl();
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterdoctorfunction(cat) : this.opdvisitService.doctors.slice())
      );

  }

  filterdoctorfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.opdvisitService.doctors.filter(country =>
      country.userName?.toLowerCase().indexOf(filterValue) === 0);

  }

  getdoctorobj(e: any) {
    this.emrservice.enabledisablebtnInfo = false;
    var val = e.option.value;
    this.opdvisitService.patientDrdetaill[0].requestDoctorName = val.userName;
    this.opdvisitService.patientDrdetaill[0].fK_RequestDoctorId = val.userId;

  }

  CheckinputDoctor(event: any) {
    this.emrservice.enabledisablebtnInfo = false;
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.doctorControll();
      this.opdvisitService.patientDrdetaill[0].fK_RequestDoctorId = 0;
      this.opdvisitService.patientDrdetaill[0].requestDoctorName = '';
    }
  }
  getSpecilityData(id) {

    this.subsepceialdata = [];
    this.emrservice.getSpeciltiyData(id).pipe(takeUntil(this.destroydother$)).subscribe((x: any) => {
      this.subsepceialdata = x;
      //  this.subSpecialityCOntrol();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  getReviewData(regid) {

    this.emrservice.GetFindingGResultByregid(regid, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroydother$)).subscribe((item: any) => {
      this.emrservice.patientEMRdetail = [];
      this.examdetailArray = [];
      this.emrservice.patientEMRdetail = item;
      this.examdetailArray = this.emrservice.patientEMRdetail.filter(item => item.pK_ExamId == this.examid);
      if (this.examdetailArray.length > 0) {
        this.imunizationdescription = this.opdvisitService.patientDrdetaill[0].immunization;
        this.fallrsikdescription = this.opdvisitService.patientDrdetaill[0].fallRisk;
        // this.Excommentdescription = this.opdvisitService.patientDrdetaill[0].examinationComments;
        this.progressivedescription = this.opdvisitService.patientDrdetaill[0].prognosis;
        this.Nutritionaldescription = this.opdvisitService.patientDrdetaill[0].nutritionalAdvice;
        this.planOfCaredescription = this.opdvisitService.patientDrdetaill[0].nextVisitPlan;
        this.refReasondescription = this.opdvisitService.patientDrdetaill[0].referralReason;
        this.pCommentdescription = this.opdvisitService.patientDrdetaill[0].personalRemarks;
        this.pgDoctor = this.opdvisitService.patientDrdetaill[0].pG_Doctor;
        this.referredCC = this.opdvisitService.patientDrdetaill[0].isReferredTo;
        this.counselorRemark = this.opdvisitService.patientDrdetaill[0].remarksForCounselor
        this.doctorRemark = this.opdvisitService.patientDrdetaill[0].drRemarks;
        this.GVP = this.opdvisitService.patientDrdetaill[0].isUnderGVP;
        this.referralDoctorName = this.opdvisitService.patientDrdetaill[0].requestToOtherDoctor;
        this.investigationRemarks = this.opdvisitService.patientDrdetaill[0].investigationRemarks;
        this.gvprRemark = this.opdvisitService.patientDrdetaill[0].gvpType;
        this.managementRemarks = this.opdvisitService.patientDrdetaill[0].managmentRemarks;
        if (this.examdetailArray[0]?.fK_DoctorDeptID > 0) {
          const subName = this.subsepceialdata.filter(item => item.pK_SubSpecialityId == this.examdetailArray[0].fK_DoctorDeptID);
          if (subName.length > 0) {
            this.subSpecialityName = subName[0]?.subSpecialityName;
          } else {
            this.subSpecialityName = null;
          }
        } else {
          this.subSpecialityName = null;
        }
        // if (this.examdetailArray[0]?.fK_RequestDoctorId > 0) {
        //   const DoctorName = this.opdvisitService.doctors.filter(item => item.userId == this.examdetailArray[0]?.fK_RequestDoctorId);
        //   if (DoctorName.length > 0) {
        //     this.doctorsName = DoctorName[0]?.userName;

        //   } else {
        //     this.doctorsName = null;
        //   }
        // } else {
        //   this.doctorsName = null;
        // }


      } else {
        this.clearData();
      }
    })
  }
  supspeicalityName(id) {
    const subName = this.subsepceialdata.filter(item => item.pK_SubSpecialityId == id);
    return subName[0]?.subSpecialityName;

  }


  // sup sepeciality auto
  // subSpecialityCOntrol(){
  //   this.subSpecialityCtrl = new FormControl();
  //   this.subSpecialityOptions = this.subSpecialityCtrl.valueChanges
  //     .pipe(
  //       startWith(''),
  //       map(cat => cat ? this.subfilterfunction(cat) : this.subsepceialdata.slice())
  //     );
  //     console.log(this.subSpecialityCtrl)
  // }
  // subfilterfunction(name: string) {

  //   const filterValue = name.toString().toLowerCase();
  //   return this.subsepceialdata.filter(country =>
  //     country.subSpecialityName?.toLowerCase().indexOf(filterValue) === 0);

  // }
  getSubspecialbj(e: any) {
    this.emrservice.enabledisablebtnInfo = false;
    var val = e.option.value;
    this.subSpecialityName = val.subSpecialityName;
    this.opdvisitService.patientDrdetaill[0].fK_DoctorDeptID = val.pK_SubSpecialityId;
  }

  Checkinputsub(event: any) {
    this.emrservice.enabledisablebtnInfo = false;
    var checkdata = event.target.value;
    if (checkdata == "") {
      //  this.subSpecialityCOntrol();
      this.opdvisitService.patientDrdetaill[0].fK_DoctorDeptID = 0;
      this.subSpecialityName = null;
    }
  }


  filterfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.commanMsgArray.filter(country =>
      country.code_Abb?.toLowerCase().indexOf(filterValue) === 0);

  }




  clearData() {
    this.isVoiceEnabled = false
    this.emrservice.enabledisablebtnInfo = false;
    this.opdvisitService.patientDrdetaill[0].immunization = null;
    this.opdvisitService.patientDrdetaill[0].fallRisk = null;
    // this.opdvisitService.patientDrdetaill[0].examinationComments = null;
    this.opdvisitService.patientDrdetaill[0].prognosis = null;
    this.opdvisitService.patientDrdetaill[0].nutritionalAdvice = null;
    this.opdvisitService.patientDrdetaill[0].nextVisitPlan = null;
    this.opdvisitService.patientDrdetaill[0].referralReason = null;
    this.opdvisitService.patientDrdetaill[0].personalRemarks = null;
    this.opdvisitService.patientDrdetaill[0].pG_Doctor = null;
    this.pgDoctor = '';
    this.opdvisitService.patientDrdetaill[0].drRemarks = null;
    this.referredCC = false;
    this.opdvisitService.patientDrdetaill[0].remarksForCounselor = null;
    this.opdvisitService.patientDrdetaill[0].isUnderGVP = false;
    this.referralDoctorName = '';
    this.subSpecialityName = '';
    this.opdvisitService.patientDrdetaill[0].fK_DoctorDeptID = 0;
    this.opdvisitService.patientDrdetaill[0].fK_RequestDoctorId = 0;
    this.opdvisitService.patientDrdetaill[0].requestDoctorName = '';
    this.opdvisitService.patientDrdetaill[0].gvpType = null;
    this.opdvisitService.patientDrdetaill[0].investigationRemarks = null;
    this.opdvisitService.patientDrdetaill[0].managmentRemarks = null;
  }
  refreedTo(type: any) {
    this.emrservice.enabledisablebtnInfo = false;
    if (type == false) {
      this.referredCC = false;
    } else {
      this.referredCC = true;
    }
  }
  ChangeGvp(type) {
    this.emrservice.enabledisablebtnInfo = false;
    if (type == false) {
      this.opdvisitService.patientDrdetaill[0].isUnderGVP = false;
    } else {
      this.opdvisitService.patientDrdetaill[0].isUnderGVP = true;
    }
  }
  SaveData(type: any) {
    if (Date.parse(this.datePipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid == 9) {
      if (this.authService.Loggeduser.usertypeid == 6) {
        if (this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr) {
           this.showspinner = false;
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
      if (this.emrservice.otherInformationPermission.isAddPermission == true) {
        if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
          if (this.examid == null || this.examid == undefined) {
            this.examid = 0;
          }

          if (this.opdvisitService.patientdetails.pkRegId) {
            this.opdvisitService.patientdetails.ageYear = this.opdvisitService.patientdetails.ageYear != null ? this.opdvisitService.patientdetails.ageYear : 0;
            let checimuAge = this.opdvisitService.documentrul.filter(item => item.propertyName == 'ImmunizationAgeLimit')[0]?.propertyValue;
            if (this.opdvisitService.patientdetails.ageYear < checimuAge) {
              if (this.opdvisitService.patientDrdetaill[0].immunization == null || this.opdvisitService.patientDrdetaill[0].immunization == undefined || this.opdvisitService.patientDrdetaill[0].immunization == "") {
                return this.dashboardService.openSnackBar("Immunization field is Required", "OK");
              }
            }
            if (this.opdvisitService.patientDrdetaill[0].isReferredTo == true && !this.opdvisitService.patientDrdetaill[0].referralReason && !this.referralDoctorName) {
              return this.dashboardService.openSnackBar("Please mention referral reason and department in case of cross referred.", "OK");
            } else if (this.opdvisitService.patientDrdetaill[0].isReferredTo == true && this.opdvisitService.patientDrdetaill[0].referralReason && !this.referralDoctorName) {
              return this.dashboardService.openSnackBar("Please mention referral department in case of cross referred.", "OK");
            } else if (this.opdvisitService.patientDrdetaill[0].isReferredTo == true && !this.opdvisitService.patientDrdetaill[0].referralReason) {
              return this.dashboardService.openSnackBar("Please mention referral reason in case of cross referred.", "OK");
            }
            if (type == 0) {
              this.showspinner = true;
            }

            this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
            this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
            this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
            this.opdvisitService.patientDrdetaill[0].requestToOtherDoctor = this.referralDoctorName;
            this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
            this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
            let payload = {

              DrExam: {
                ...this.opdvisitService.patientDrdetaill[0]

              },

              DrFinding: []
              ,
              DrDiag: [],
              DrPrescrip: [
              ],
              DrInvest: []
              , DrSurgery: []
            }
            try {
              this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroydother$)).subscribe(data => {
                if (data['statusCode'] == 1) {
                  this.isVoiceEnabled = false
                  this.emrservice.enabledisablebtnInfo = true;
                  if (this.examid > 0) {
                    this.emrservice.savedrWorkupTrackingSatus('Modify Doctor Workup', 'true', 'DR');
                  } else {
                    this.emrservice.savedrWorkupTrackingSatus('Doctor Workup', 'false', 'DR');
                  }
                  this.showspinner = false;
                  this.examid = data['id'];
                  this.emrservice.examid = data['id'];
                  // this.emrservice.content.next('2');
                  // this.getReviewData(this.opdvisitService.patientdetails.pkRegId);
                  if (this.opdvisitService.patientDrdetaill[0].requestDoctorName != '' && this.opdvisitService.patientDrdetaill[0].requestDoctorName != null && this.opdvisitService.patientDrdetaill[0].requestDoctorName != undefined) {
                    this.dashboardService.addremark.PkOpdremarksId = 0;
                    let remakr = 'Patient Referred to ' + this.opdvisitService.patientDrdetaill[0].requestDoctorName
                    this.dashboardService.addremark.Remarks = remakr.substring(0, 250);
                    this.dashboardService.addremark.FkVisitId = this.emrservice.visitid;
                    this.dashboardService.addremark.FkRegId = this.opdvisitService.patientdetails.pkRegId;
                    this.dashboardService.addremark.FromWhere = this.authService.Loggeduser.userid;
                    this.dashboardService.addremark.userName = this.authService.Loggeduser.username;
                    this.dashboardService.addremark.Source = this.opdvisitService.patientdetails.pkRegId;
                    let todaysdate = new Date();
                    this.dashboardService.addremark.EnterTime = this.datePipe.transform(todaysdate, "hh:mm:ss a");
                    this.emrservice.add_dashboard_remark(this.dashboardService.addremark).pipe(takeUntil(this.destroydother$)).subscribe((x: any) => {
                      this.dashboardService.addremark = {};
                    });
                  }
                  this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
                  this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
                  this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
                } else {

                  this.showspinner = false;
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              },
                err => {

                  this.showspinner = false;
                  if (err.status == 403) {
                    this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                  }
                  else if (err.error.statusCode == 422) {
                    this.dashboardService.openSnackBar(err.error.message, "OK");
                  }
                  else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }

                }
              );
            }
            catch (error) {

              this.showspinner = false;
            }

          } else {

            this.dashboardService.openSnackBar("Please Select Patient", "OK");
          }

        } else {

          this.dashboardService.openSnackBar("Please Select Visit List", "OK");
        }
      } else {
        this.dashboardService.openSnackBar("Add Permission Denied", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
    }
  }
  refReasonPOpup(type) {
    const dialogRef = this.dialog.open(HelpListPopupComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        typeid: type
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroydother$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisablebtnInfo = false;
        if (type == 47) {
          // this.opdvisitService.patientDrdetaill[0].examinationComments = result;
        } else if (type == 46) {
          this.opdvisitService.patientDrdetaill[0].prognosis = result;
        } else if (type == 51) {
          this.opdvisitService.patientDrdetaill[0].nutritionalAdvice = result;
        } else if (type == 45) {
          this.opdvisitService.patientDrdetaill[0].nextVisitPlan = result;
        }
        else if (type == 49) {
          this.opdvisitService.patientDrdetaill[0].referralReason = result;
        }
      }
    });
  }

  // helplist pop up 
  refReasondyamicPOpup(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroydother$)).subscribe(result => {

      if (result != 0) {
        this.emrservice.enabledisablebtnInfo = false;
        if (type == 1) {
          this.opdvisitService.patientDrdetaill[0].immunization = result;
        } else if (type == 2) {
          this.opdvisitService.patientDrdetaill[0].fallRisk = result;
        } else if (type == 3) {
          this.opdvisitService.patientDrdetaill[0].personalRemarks = result;
        } else if (type == 5) {
          this.opdvisitService.patientDrdetaill[0].drRemarks = result;
        } else if (type == 6) {
          this.opdvisitService.patientDrdetaill[0].remarksForCounselor = result;
        } else if (type == 7) {
          this.opdvisitService.patientDrdetaill[0].investigationRemarks = result;
        } else if (type == 8) {
          this.opdvisitService.patientDrdetaill[0].managmentRemarks = result;
        } else if (type == 9) {
          this.opdvisitService.patientDrdetaill[0].gvpType = result;
        } else if (type == 10) {
          this.opdvisitService.patientDrdetaill[0].pG_Doctor = result;
        }
      }
    });
  }



  Refralpopup(type) {
    if (type == 1) {
      document.getElementById("RefModal").style.display = "Block";
    } else {
      document.getElementById("RefModal").style.display = "None";
    }

  }
  rowdata: any = {};
  changeTableRowColor(row: any, idx: any) {

    if (this.rowClicked === idx) {
      this.subSpecialityName = '';
      this.rowClicked = -1;
      this.rowdata = {};
    }
    else {
      this.subSpecialityName = row.subSpecialityName;
      this.rowdata = row;
      this.rowClicked = idx;
    }

  }
  onReviewGrid(desc: any) {
    this.emrservice.enabledisablebtnInfo = false;
    if (this.nextreviewrocesses.length > 0) {
      var newchar = '';
      this.nextreviewrocesses.forEach(item => {
        newchar = item + ',' + newchar;
      })
      this.referralDoctorName = newchar;
      document.getElementById("RefModal").style.display = "None";
    } else {
      this.referralDoctorName = desc;
      document.getElementById("RefModal").style.display = "None";
    }

  }

  reprocessHomeProcesses(exe, event: any) {
    this.emrservice.enabledisablebtnInfo = false;
    if (event.checked) {
      this.nextreviewrocesses.push(exe)
    } else {
      var index = this.nextreviewrocesses.indexOf(exe)
      if (index > -1) {
        this.nextreviewrocesses.splice(index, 1);
      }
    }
  }
  enableButton() {
    this.emrservice.enabledisablebtnInfo = false;
  }
  refferchange(event) {
    this.emrservice.enabledisablebtnInfo = false;
    this.opdvisitService.patientDrdetaill[0].isReferredTo = event.checked;
  }
  closedialog() {
    this.dialogRef.close();
    this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
  }
  SaveDrworkup() {
    this.showspinner = true;
    if (this.emrservice.examid > 0) {
      this.emrservice.notifyComponents();
    } else {
      this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.emrservice.examid ? this.emrservice.examid : 0;
      this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
      this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
      this.opdvisitService.patientDrdetaill[0].requestToOtherDoctor = this.referralDoctorName;
      this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
      this.opdvisitService.patientDrdetaill[0].isEdit = this.emrservice.examid > 0 ? true : false;
      let payload = {

        DrExam: {
          ...this.opdvisitService.patientDrdetaill[0]

        },

        DrFinding: []
        ,
        DrDiag: [],
        DrPrescrip: [
        ],
        DrInvest: []
        , DrSurgery: []
      }

      this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroydother$)).subscribe(data => {
        this.showspinner = false;
        if (data['statusCode'] == 1) {
          this.examid = data['id'];
          this.emrservice.examid = data['id'];
          this.emrservice.notifyComponents();
        }

      }, err => {
        this.showspinner = false;
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }

      });
    }
  }


  onVoiceFocus(fieldName: string) {
    debugger
    if (!this.isVoiceEnabled) return;
    this.VoiceRecognitionService.activeDischargeField = fieldName;
    const newIndex = this.opdFieldSequence.indexOf(this.VoiceRecognitionService.activeDischargeField);
    if (newIndex !== -1 && newIndex !== this.opdCurrentFieldIndex) {
      this.opdCurrentFieldIndex = newIndex;
    }

    this.VoiceRecognitionService.startDischarge(this.VoiceRecognitionService.activeDischargeField, (spokenText: string) => {
      console.log(`[Voice] ${this.VoiceRecognitionService.activeDischargeField} ->`, spokenText);

      if (spokenText.toLowerCase().trim() === 'next') {
        this.moveToNextField();
        return;
      }

      if (spokenText) {
        this.emrservice.enabledisablebtnInfo = false;
      }
      const model = this.opdvisitService.patientDrdetaill[0];

      switch (this.VoiceRecognitionService.activeDischargeField) {
        case 'imunizationlist':
          model.immunization = this.mergeInput(model.immunization, spokenText);
          break;
        case 'fallRisk':
          model.fallRisk = this.mergeInput(model.fallRisk, spokenText);
          break;
        case 'prognosis':
          model.prognosis = this.mergeInput(model.prognosis, spokenText);
          break;
        case 'nutritionalAdvice':
          model.nutritionalAdvice = this.mergeInput(model.nutritionalAdvice, spokenText);
          break;
        case 'nextVisitPlan':
          model.nextVisitPlan = this.mergeInput(model.nextVisitPlan, spokenText);
          break;
        case 'referralReason':
          model.referralReason = this.mergeInput(model.referralReason, spokenText);
          break;
        case 'personalRemarks':
          model.personalRemarks = this.mergeInput(model.personalRemarks, spokenText);
          break;
        case 'doctorRemark':
          model.drRemarks = this.mergeInput(model.drRemarks, spokenText);
          break;
        case 'referralDoctorName':
          this.referralDoctorName = this.mergeInput(this.referralDoctorName, spokenText);
          break;
        case 'gvpr':
          model.gvpType = this.mergeInput(model.gvpType, spokenText);
          break;
        case 'investigation':
          model.investigationRemarks = this.mergeInput(model.investigationRemarks, spokenText);
          break;
        case 'management':
          model.managmentRemarks = this.mergeInput(model.managmentRemarks, spokenText);
          break;
        case 'opeartor':
          model.pG_Doctor = this.mergeInput(model.pG_Doctor, spokenText);
          break;
      }
    });
  }



  onVoiceBlur(fieldName: string) {
    
    if (this.isVoiceEnabled) {
      this.VoiceRecognitionService.stopDischarge(fieldName);
      this.VoiceRecognitionService.activeDischargeField = null;

    }
  }
  moveToNextField() {

    this.VoiceRecognitionService.stopDischarge(this.opdFieldSequence[this.opdCurrentFieldIndex]);

    if (this.opdCurrentFieldIndex < this.opdFieldSequence.length - 1) {
      const nextField = this.opdFieldSequence[++this.opdCurrentFieldIndex];
      this.VoiceRecognitionService.activeDischargeField = nextField;
      const tryFocus = (attempt = 0) => {
        const inputElement = document.querySelector(`[name="${nextField}"]`) as HTMLElement;

        if (inputElement) {
          inputElement.focus();
        } else if (attempt < 5) {
          setTimeout(() => tryFocus(attempt + 1), 200);
        } else {
          console.error(`[Voice] Failed to find: ${nextField}`);
        }
      };

      setTimeout(() => tryFocus(), 100);
    }
  }


  mergeInput(original: string, voice: string): string {
    if (!voice?.trim()) return original || '';
    if (!original) return voice.trim();

    const combined = `${original} ${voice}`.trim();
    if (combined.endsWith(voice.trim())) return combined;

    return combined;
  }


  toggleVoice() {

    if (this.isVoiceEnabled) {
      this.opdCurrentFieldIndex = 0;
      const firstField = this.opdFieldSequence[this.opdCurrentFieldIndex];
      this.VoiceRecognitionService.activeDischargeField = firstField;
      setTimeout(() => {
        const element = document.querySelector(`[name="${this.VoiceRecognitionService.activeDischargeField}"]`) as HTMLElement;
        if (element) element.focus();
        // this.onVoiceFocus(this.VoiceRecognitionService.activeDischargeField);
      }, 200);
    }
  }


  getCurrentField(): string {
    return this.opdFieldSequence[this.opdCurrentFieldIndex] || 'imunizationlist';
  }



}
